import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import { AppErrorBoundary, reloadForNewRelease } from "./components/AppErrorBoundary";
import "./index.css";

// After a new release, an already-open tab may ask for page files that no
// longer exist. Reload once to pick up the new release instead of crashing.
window.addEventListener("vite:preloadError", (event) => {
  if (reloadForNewRelease()) event.preventDefault();
});

createRoot(document.getElementById("root")!).render(
  <AppErrorBoundary>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </AppErrorBoundary>
);
